import { render, staticRenderFns } from "./order-deposit-history.vue?vue&type=template&id=007b5a66&scoped=true"
import script from "./order-deposit-history.vue?vue&type=script&lang=js"
export * from "./order-deposit-history.vue?vue&type=script&lang=js"
import style0 from "./order-deposit-history.vue?vue&type=style&index=0&id=007b5a66&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "007b5a66",
  null
  
)

export default component.exports